import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import CreaEquipoSaludPublica from "./CreaEquipos/CreaEquipoSaludPublica";
import DequipoSaludPublica from "../../EliminaEquipos/DequipoSaludPublica";

function EquipoSaludPublica({ idSolicitud }) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  // Función para obtener la lista
  const fetchList = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoSaludPublicaPorSolicitudId?SolicitudId=${idSolicitud}`,
    })
      .then((res) => setList(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchList();
  }, []);

  const nombreRuta =
    window.location.href.split("/")[
      window.location.href.split("/").indexOf("#") + 1
    ];
  const handleDelete = (id) => {
    setList((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <div className="test container text-center">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            2.3. Equipo Primario de Mejoramiento de Salud Pública y Promoción y
            Prevención
          </h6>
        </div>
        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaEquipoSaludPublica
                idSolicitud={idSolicitud}
                onCreated={fetchList}
              />
            )}

          <div className="table-responsive">
            <table
              className="table table-bordered"
              width="100%"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Servicio</th>
                  <th>Cargo</th>
                  <th>Lider</th>
                  {nombreRuta === "ProcesoAutoevaluacion" && <th>Elimina</th>}
                </tr>
              </thead>
              <tbody>
                {list.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nombre}</td>
                    <td>{item.servicio}</td>
                    <td>{item.cargo}</td>
                    <td>{item.lider}</td>
                    {nombreRuta === "ProcesoAutoevaluacion" && (
                      <td>
                        <DequipoSaludPublica
                          id={item.id}
                          onDelete={handleDelete}
                        />
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoSaludPublica;
